var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var B = Object.create,
    b = Object.defineProperty,
    F = Object.getPrototypeOf,
    O = Object.prototype.hasOwnProperty,
    K = Object.getOwnPropertyNames,
    M = Object.getOwnPropertyDescriptor,
    q = Object.getOwnPropertySymbols,
    R = Object.prototype.propertyIsEnumerable;

var m = Object.assign,
    v = function v(e) {
  return b(e, "__esModule", {
    value: !0
  });
};

var d = function d(e, t) {
  var c = {};

  for (var n in e) {
    O.call(e, n) && t.indexOf(n) < 0 && (c[n] = e[n]);
  }

  if (e != null && q) {
    var _iterator = _createForOfIteratorHelper(q(e)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var n = _step.value;
        t.indexOf(n) < 0 && R.call(e, n) && (c[n] = e[n]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return c;
};

var U = function U(e, t) {
  for (var c in t) {
    b(e, c, {
      get: t[c],
      enumerable: !0
    });
  }
},
    A = function A(e, t, c) {
  if (t && typeof t == "object" || typeof t == "function") {
    var _iterator2 = _createForOfIteratorHelper(K(t)),
        _step2;

    try {
      var _loop = function _loop() {
        var n = _step2.value;
        !O.call(e, n) && n !== "default" && b(e, n, {
          get: function get() {
            return t[n];
          },
          enumerable: !(c = M(t, n)) || c.enumerable
        });
      };

      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return e;
},
    P = function P(e) {
  return e && e.__esModule ? e : A(v(b(e != null ? B(F(e)) : {}, "default", {
    value: e,
    enumerable: !0
  })), e);
};

v(exports);
U(exports, {
  blockContentToPlainText: function blockContentToPlainText() {
    return J;
  },
  default: function _default() {
    return G;
  }
});

var k = P(require("react")),
    r = P(require("prop-types")),
    f = P(require("@sanity/block-content-to-react")),
    z = function z(i) {
  var e = i.content,
      t = i.className,
      _i$serializers = i.serializers,
      c = _i$serializers === void 0 ? {} : _i$serializers,
      n = d(i, ["content", "className", "serializers"]);
  if (!e) throw new Error("No `content` provided to PortableText.");
  return k.default.createElement(f.default, m({
    blocks: e,
    className: t,
    serializers: D(c),
    renderContainerOnSingleChild: !0
  }, n));
},
    G = z;

z.propTypes = {
  content: r.default.array.isRequired,
  className: r.default.string,
  serializers: r.default.shape({
    link: r.default.func,
    strong: r.default.func,
    em: r.default.func,
    underline: r.default.func,
    del: r.default.func,
    code: r.default.func,
    ul: r.default.func,
    ol: r.default.func,
    li: r.default.func,
    h1: r.default.func,
    h2: r.default.func,
    h3: r.default.func,
    h4: r.default.func,
    h5: r.default.func,
    h6: r.default.func,
    blockquote: r.default.func
  })
};

var D = function D(e) {
  var _e$container = e.container,
      t = _e$container === void 0 ? "div" : _e$container,
      c = e.link,
      n = e.strong,
      i = e.em,
      g = e.underline,
      C = e.del,
      s = e.code,
      N = e.ul,
      S = e.ol,
      a = e.li,
      h = e.h1,
      _ = e.h2,
      w = e.h3,
      T = e.h4,
      j = e.h5,
      x = e.h6,
      W = e.blockquote,
      y = d(e, ["container", "link", "strong", "em", "underline", "del", "code", "ul", "ol", "li", "h1", "h2", "h3", "h4", "h5", "h6", "blockquote"]),
      E = {
    h1: h,
    h2: _,
    h3: w,
    h4: T,
    h5: j,
    h6: x,
    blockquote: W
  };
  return {
    container: t,
    marks: H(m({
      link: c,
      strong: n,
      em: i,
      underline: g,
      code: s,
      "strike-through": C
    }, y)),
    list: function list(o) {
      var l = o.type,
          u = o.children,
          p = l === "bullet" ? N : S;
      return p ? p({
        children: u
      }) : f.default.defaultSerializers.list(o);
    },
    listItem: function listItem(o) {
      var l = o.children;
      return a ? a({
        children: l
      }) : f.default.defaultSerializers.listItem(o);
    },
    types: m({
      block: function block(o) {
        var l = o.node.style,
            u = o.children;
        return E[l] ? E[l]({
          children: u
        }) : y[l] ? y[l]({
          children: u
        }) : f.default.defaultSerializers.types.block(o);
      }
    }, Object.entries(y).reduce(function (o, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          l = _ref2[0],
          u = _ref2[1];

      var p = function p(_ref3) {
        var $ = _ref3.node;
        return k.default.createElement(u, $);
      };

      return p.displayName = "".concat(I(l), "Wrapper"), o[l] = p, o;
    }, {}))
  };
},
    H = function H(e) {
  return Object.entries(e).reduce(function (t, _ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        c = _ref5[0],
        n = _ref5[1];

    if (n) {
      var i = function i(h) {
        var g = h._type,
            C = h._key,
            s = h.mark,
            N = h.markKey,
            S = h.children,
            a = d(h, ["_type", "_key", "mark", "markKey", "children"]);

        if (typeof s == "object") {
          var _ = s._type,
              w = s._key,
              T = d(s, ["_type", "_key"]);
          Object.entries(T).forEach(function (_ref6) {
            var _ref7 = _slicedToArray(_ref6, 2),
                j = _ref7[0],
                x = _ref7[1];

            a[j] = x;
          });
        }

        return k.default.createElement(n, a, S);
      };

      i.displayName = "".concat(I(c), "Wrapper"), t[c] = i;
    }

    return t;
  }, {});
},
    J = function J() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return e.map(function (t) {
    return t._type === "block" && t.children ? t.children.map(function (c) {
      return c.text;
    }).join("") : "";
  }).join("\n\n");
},
    I = function I(e) {
  return e.slice(0, 1).toUpperCase() + e.slice(1);
};